import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Elements
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import SectionHeading from '../SectionHeading/SectionHeading';
import PageHero from '../PageHero/PageHero';

const MASONRY_ROW = 4;   // px, matches grid-auto-rows in index.css
const MASONRY_GAP = 20;  // px, matches the tile margin-bottom in index.css

export default class GallerySection extends Component {

    constructor(props) {
        super(props);
        this.lightbox = null;
    }

    componentDidMount() {
        this.lightbox = new PhotoSwipeLightbox({
          gallery: '#clinic-images-gallery',
          children: 'a',
          pswpModule: () => import('photoswipe'),
        });
        this.lightbox.init();
        window.addEventListener('resize', this.layoutMasonry);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.layoutMasonry);
        if (this.lightbox) {
          this.lightbox.destroy();
          this.lightbox = null;
        }
    }

    // PhotoSwipe needs the photo's real size, not the thumbnail's rendered size
    updateDimention = (event) => {
        let image = event.target;
        let aTag = image.closest('a');
        aTag.setAttribute("data-pswp-width", image.naturalWidth);
        aTag.setAttribute("data-pswp-height", image.naturalHeight);
        this.sizeTile(aTag);
    }

    // Masonry on a CSS grid: each tile spans as many small rows as its photo is tall,
    // so photos keep their proportions and still fill the columns left to right.
    sizeTile(tile) {
        if(!tile.parentNode || !tile.parentNode.classList.contains('gallery-masonry')) {
            return;
        }
        const image = tile.querySelector('img');
        const height = image.getBoundingClientRect().height;
        if(height > 0) {
            tile.style.gridRowEnd = `span ${Math.ceil((height + MASONRY_GAP) / MASONRY_ROW)}`;
        }
    }

    layoutMasonry = () => {
        document.querySelectorAll('.gallery-masonry > .gallery-tile').forEach(tile => this.sizeTile(tile));
    }

    renderTile(photo, index) {
        const name = this.props.clinic_name || 'Clinic';
        return (
            <a
                href={photo}
                className='gallery-tile clinic-images-gallery-item wow fadeInUp'
                data-wow-delay={`${0.08 * (index % 6)}s`}
                key={'clinic-images-gallery-' + index}
                target="_blank"
                rel="noreferrer"
                aria-label={`Open ${name} photo ${index + 1}`}
                >
                <img src={photo} alt={`${name}, gallery ${index + 1}`} className="gallery-tile__img" loading="lazy" onLoad={this.updateDimention}/>
                <span className="gallery-tile__overlay"><i className="fa-solid fa-up-right-and-down-left-from-center"></i></span>
            </a>
        );
    }

    render() {
        let photos = this.props.gallery.general.slice();
        if(this.props.as_section !== undefined) {
            photos.length = Math.min(photos.length, 3);
        }

        if(!this.props.as_section) {
            const name = this.props.clinic_name;
            return (
            <>
                <PageHero eyebrow="Gallery" title="Inside our clinic"
                    text={`A look inside ${name || 'our clinic'}: our space, our care and the smiles we've created.`}
                    meta={photos.length > 0 ?
                        <span className="page-hero__chip"><i className="fa-regular fa-images"></i>{photos.length} {photos.length === 1 ? 'photo' : 'photos'}</span> : null}/>
                {photos.length > 0 ?
                <div className="gallery-page">
                    <Container>
                        <div id="clinic-images-gallery" className="gallery-masonry">
                            {photos.map((photo, index) => this.renderTile(photo, index))}
                        </div>
                    </Container>
                </div> : null}
            </>
            );
        }

        if(photos.length === 0) {
            return <></>
        }
        return (
        <div className="space-medium">
            <Container>
                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <SectionHeading title="Gallery"/>
                    </Col>
                </Row>
                <Row id="clinic-images-gallery" className="gallery-row">
                {photos.map((photo, index) => (
                    <Col lg={4} md={4} sm={6} xs={12} key={index}>
                        {this.renderTile(photo, index)}
                    </Col>
                ))}
                </Row>
                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <div className="mt40 text-center">
                            <Link to="/gallery" className="ui-btn ui-btn--ghost">
                                <i className="fa-regular fa-images"></i>
                                <span>View Gallery</span>
                                <i className="fa-solid fa-arrow-right ui-btn__arrow"></i>
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
        );
    }
}
